import React from "react";
import Main from "./main";
import Footer from "../../components/footer";
import Box from "@mui/material/Box";

const Index = () => {
  return (
    <Box>
      <Main />
      <Footer />
    </Box>
  );
};

export default Index;
